import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-24 px-6 bg-[#0f0f0f] border-t border-white/5" data-id="element-52">
      <div className="max-w-4xl mx-auto" data-id="element-53">
        <FadeIn data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-12 tracking-tight" data-id="element-55">
            LA ESCENA EXACTA QUE SE REPITE
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-56">
          <FadeIn delay={0.1} data-id="element-57">
            <p className="text-xl text-gray-300 mb-8" data-id="element-58">
              Si esto te pasa, lo vas a reconocer sin que te lo explique
              demasiado:
            </p>
          </FadeIn>

          <div className="space-y-4 pl-4 border-l border-white/10" data-id="element-59">
            {['Sales del trabajo con la cabeza llena.', 'Dices “hoy sí le doy a mi meta”.', 'Te sientas… y tu cuerpo pide alivio.', 'Agarras el teléfono “para desconectar”.', 'Y cuando quieres reaccionar ya estás en el mismo lugar: cansado, culpable, y con cero avance.'].map((item, i) => <FadeIn key={i} delay={0.1 + i * 0.05} direction="right" data-id="element-60">
                <div className="flex items-start gap-4" data-id="element-61">
                  <XCircle className="w-6 h-6 text-red-500/80 shrink-0 mt-1" data-id="element-62" />
                  <p className="text-lg md:text-xl text-gray-300" data-id="element-63">{item}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.4} className="mt-12 p-8 bg-white/5 border border-white/10 rounded-sm" data-id="element-64">
            <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-65">
              Lo peor no es perder tiempo. Lo peor es la frase que aparece
              después:
            </p>
            <p className="text-3xl md:text-4xl font-black text-white italic mb-8" data-id="element-66">
              "¿Qué me pasa? Si yo sé que puedo."
            </p>
            <p className="text-lg md:text-xl text-gray-300" data-id="element-67">
              Esa frase te erosiona. Porque no estás fallando por falta de
              capacidad. <br data-id="element-68" />
              <span className="text-blue-500 font-bold" data-id="element-69">
                Estás fallando por falta de sistema.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}